<template>
  <div id="projects" class="projects p-3 pt-lg-5 p-lg-4 container-fluid" data-bs-target="#projects">
    <h1 class="title_projects fw-bold max-auto">PROJECTS</h1>
    <div class="row pt-3 pt-lg-5 pb-3 pb-lg-5">
      <!-- WORK PROJECTS -->
      <div class="col-sm">
        <h1 class="pb-3 pb-lg-5 pt-5 pt-lg-0 fw-bold">WORK</h1>
        <div class="accordion" id="accordionJob">
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingJAut">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseJAut" aria-expanded="true" aria-controls="collapseJAut">
                <strong>Junior Automation Engineer</strong>
              </button>
            </h2>
            <div id="collapseJAut" class="accordion-collapse collapse" aria-labelledby="headingJAut"
              data-bs-parent="#accordionJob">
              <div class="accordion-body text-start">
                <p class="">
                  During the final two semesters of my bachelor's degree, I transitioned to a part-time study model to gain hands-on industry experience. I joined Autcomp Automation AG in Stansstad as a Junior Automation Engineer, supporting the team on several projects, most notably, the renewal of the ventilation system in the Gotthard Road Tunnel.
                </p> 
                <p class=""> 
                  My primary responsibility was to expand and adapt existing code in Siemens TIA, based on project documentation and established concepts. Additionally, I contributed to other automation projects and created electrical schematics, an area where I could apply skills developed during my apprenticeship.
                </p>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingELP">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseELP" aria-expanded="true" aria-controls="collapseELP">
                <strong>Electrical Planner</strong>
              </button>
            </h2>
            <div id="collapseELP" class="accordion-collapse collapse" aria-labelledby="headingELP"
              data-bs-parent="#accordionJob">
              <div class="accordion-body text-start">
                <p class="">
                  As an Electrical Planner, I was responsible for creating electrical plans, schematics, and tender documents to support electricians on construction sites.
                </p>
                <p class="">
                  During my two-year tenure at Network 41 AG following my apprenticeship, and through summer jobs at HT-Infraserv AG, I contributed to several interesting and diverse projects. Some of these are highlighted in the list below:
                </p>
                <a href="https://www.google.ch/maps/place/Hochstrasser+AG+Kaffeer%C3%B6sterei/@47.0488536,8.2694026,106m/data=!3m1!1e3!4m6!3m5!1s0x478ffb3911826457:0x91fc009c32b76518!8m2!3d47.0489444!4d8.2696281!16s%2Fg%2F1td1259t?entry=ttu"
                  target="_blank">Hochstrasser AG - New coffee roastery in Lucerne</a><br />
                <a href="https://www.google.ch/maps/place/Aarau/@47.3911964,8.0503103,248m/data=!3m1!1e3!4m6!3m5!1s0x47903bf01e450701:0x1f73bd9ca50dce70!8m2!3d47.3913661!4d8.0512862!16s%2Fm%2F0r3t4xh?entry=ttu"
                  target="_blank">Aarau railroad station - Renewal of the lighting</a><br />
                <a href="https://www.hp-arch.ch/werkverzeichnis?c=Neubau_Doppelturnhalle_in_Schenkon"
                  target="_blank">Village of Schenkon - New double sports hall</a><br />
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFTTS">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFTTS" aria-expanded="false" aria-controls="collapseFTTS">
                <strong>Fiber to the Street (FTTS)</strong>
              </button>
            </h2>
            <div id="collapseFTTS" class="accordion-collapse collapse" aria-labelledby="headingFTTS"
              data-bs-parent="#accordionJob">
              <div class="accordion-body text-start">
                <p class="">
                  Network 41 AG, where I completed my apprenticeship and worked for two years, provides engineering services for Swisscom AG in support of their nationwide Fiber to the Street (FTTS) rollout. The goal of this strategy is to reduce the length of copper lines by bringing fiber optic cables closer to homes, right up to street-side shafts. There, the optical signals are converted into electrical signals via so-called mCANs, allowing for faster and more stable internet connections.
                </p>
                <p class="">
                  I had the opportunity to receive additional training to work within Swisscom's project management framework. As a result, I was entrusted with managing FTTS implementation projects in two small villages, marking my first steps as a project manager.
                </p>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingMobile">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseMobile" aria-expanded="false" aria-controls="collapseMobile">
                <strong>Mobile Antennas</strong>
              </button>
            </h2>
            <div id="collapseMobile" class="accordion-collapse collapse" aria-labelledby="headingMobile"
              data-bs-parent="#accordionJob">
              <div class="accordion-body text-start">
                <p class="">
                  In addition to supporting the FTTS rollout, Network 41 AG also provides engineering services for Swisscom AG's mobile network expansion. When a new mobile antenna site is selected, a range of technical requirements must be met, one of the most critical being a reliable electrical power supply.
                </p>
                <p class="">
                  I was responsible for conducting on-site assessments across various locations in Switzerland, ensuring that power supply plans were tailored to meet the specific needs of each mobile antenna installation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- UNIVERSITY PROJECTS -->
      <div class="col-sm">
        <h1 class="pb-3 pb-lg-5 pt-5 pt-lg-0 fw-bold">UNIVERSITY</h1>
        <div class="accordion" id="accordionUniversity">
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingBAT">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseBAT" aria-expanded="false" aria-controls="collapseBAT">
                <strong>Bachelor's Thesis - AMZ Racing</strong>
              </button>
            </h2>
            <div id="collapseBAT" class="accordion-collapse collapse" aria-labelledby="headingBAT"
              data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  For my bachelor's thesis, and as part of my industrial work, I had the incredible opportunity to join the AMZ Racing team of the 2025 season's car called Aurona. Each year, the team designs and builds a new high-performance electric race car to compete in Formula Student Electric (FSE) events, with the ambitious goal of creating the best electric race car in the competition.
                </p>
                <p class="">
                  My specific work package was focused on the development of the Low Voltage Battery Management System (LV BMS) as well as the low voltage supply. This subsystem is responsible for safely distributing and managing all low voltage power throughout the car, enabling critical electronics, sensors, and control units to function reliably under demanding racing conditions. The complexity of this task led to the design of five custom PCB's, one of which features a stacked configuration to optimize space and functionality within the vehicle's tight packaging constraints.
                </p>
                <p class="">
                  The outcome of the first semester and the conceptual phase of the project can be looked at in the following report of the industrial work unit:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1GmwsDQu2c8Txog67yg5Z6j57cnKDTUFt/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                    margin-bottom: 20px;
                  ">
                  Report - Industrial Work
                </button>
                <p class="">
                  The second semester and realization, testing and event phase of the project can be looked at in the bachelor's thesis:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1yg37aL6P_dEkNZmWpyPoWw2Qy-nieslD/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report - Bachelor's Thesis
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingPREN">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsePREN" aria-expanded="false" aria-controls="collapsePREN">
                <strong>Project Unit - Gravel Cleaner Robot</strong>
              </button>
            </h2>
            <div id="collapsePREN" class="accordion-collapse collapse" aria-labelledby="headingPREN"
              data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  This mandatory university project was focused on practical project management, interdisciplinary teamwork, and problem-solving with an emphasis on economic and environmental sustainability. The goal was to develop a concept for a robot capable of cleaning gravel surfaces.
                </p>
                <p class="">
                  Our team of seven students came from three departments, Electrical Engineering, Mechanical Engineering, and Software Engineering, allowing for a well-rounded and collaborative approach to the project. The outcome of this first phase was a detailed concept, documented in a project report (in German), which is available at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/18JhXxEUv2N6iaZRuUeWObu1FcYQFXUQx/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                    margin-bottom: 20px;
                  ">
                  Report 1 - Concept
                </button>
                <p class="">
                  The second project built upon the initial concept phase, has the goal of turning our design into a functional, working prototype. As is often the case, bringing a concept to life presented unexpected challenges. However, our team successfully overcame them and ultimately won the final competition, outperforming all 26 participating teams.
                </p>
                <p class="">
                  Notably, we were the only team to receive the highest grade in both project units, highlighting the consistency and quality of our work. The final project report (in German) can be accessed here:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1EfRihjsRAqfgzEjhbJF00olKRSYwLgvi/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report 2 - Realization
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingGantryApparatus">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseGantryApparatus" aria-expanded="false" aria-controls="collapseGantryApparatus">
                <strong>PLC Systems - Gantry Apparatus</strong>
              </button>
            </h2>
            <div id="collapseGantryApparatus" class="accordion-collapse collapse"
              aria-labelledby="headingGantryApparatus" data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  This voluntary project was completed during my semester abroad in Australia, where I had the opportunity to tackle automation challenges independently and explore new technologies and methodologies. Key topics covered included ladder logic (LAD), Structured Text Language (STL), Function Block Diagram (FBD), timers, counters, digital and analog I/O, PID control, state machines, and more.
                </p>
                <p class="">
                  The unit included three distinct projects, with the second project being assigned by our professors. In this project, we worked with a gantry apparatus that was designed to perform a specific task. My team and I were tasked with programming and configuring the system to meet the given requirements. The final report can be accessed at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1Kc4IYmSTDgHl72YuzYovUBOQalbs3SKL/view?usp=sharing'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFunctionGenerator">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFunctionGenerator" aria-expanded="false"
                aria-controls="collapseFunctionGenerator">
                <strong>PLC Systems - Function Generator</strong>
              </button>
            </h2>
            <div id="collapseFunctionGenerator" class="accordion-collapse collapse"
              aria-labelledby="headingFunctionGenerator" data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  The third project in the PLC Systems unit was open-ended, allowing teams to develop their own ideas. My team chose to design and implement a function generator using a Siemens PLC. The project involved generating various waveform outputs through programmable logic, demonstrating both creativity and a solid understanding of PLC capabilities. The final report can be accessed at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1HcmCtn82CRH5fLdMpNZm8o2Sd7WLdEeA/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingRogowski">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseRogowski" aria-expanded="false" aria-controls="collapseRogowski">
                <strong>Advanced Electronics - Rogowski Coil</strong>
              </button>
            </h2>
            <div id="collapseRogowski" class="accordion-collapse collapse" aria-labelledby="headingRogowski"
              data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  This voluntary unit was designed to deepen our understanding of advanced electronics, building upon the foundation laid in the Electronics 2 unit. It also covered important topics such as noise reduction, PCB design, and common challenges and applications in the industry.
                </p>
                <p class="">
                  Like the unit Electronics 2, this unit included a project. In a team of two, we tasked ourselves with designing and building a Rogowski coil to measure AC at a frequency of 50 Hz. This coil, known for its non-intrusive measurement method, was used to capture accurate AC measurements for practical applications. The final report (in German) can be read at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1IWTPuyA_72i_hW-cgPbCt0U-rQIFvpgV/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingSmoke">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseSmoke" aria-expanded="false" aria-controls="collapseSmoke">
                <strong>Electronics 2 - Smoke Detector</strong>
              </button>
            </h2>
            <div id="collapseSmoke" class="accordion-collapse collapse" aria-labelledby="headingSmoke"
              data-bs-parent="#accordionUniversity">
              <div class="accordion-body text-start">
                <p class="">
                  This mandatory unit provided intermediate-level knowledge of key electronic components and systems, including transistors, operational amplifiers, oscillators, AD and DA converters, filters, noise reduction, and PCB design.
                </p>
                <p class="">
                  As part of the unit, we were tasked with a project to apply what we had learned. In a team of two, we designed and built a fully functional optical smoke detector. The project gave us hands-on experience with circuit design, sensor integration, and PCB layout. The final report (in German) can be accessed at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1Zyg_QEWcTSnO1Xz3YMKKiPoTNiJD66wS/view?usp=drive_link'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Report
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- PRIVATE PROJECTS -->
      <div class="col-sm">
        <h1 class="pt-5 pt-lg-0 pb-3 pb-lg-5 fw-bold">PRIVATE</h1>
        <div class="accordion" id="accordionPrivate">
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingConsole">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseConsole" aria-expanded="true" aria-controls="collapseConsole">
                <strong>Steering Console V2</strong>
              </button>
            </h2>
            <div id="collapseConsole" class="accordion-collapse collapse" aria-labelledby="headingConsole"
              data-bs-parent="#accordionPrivate">
              <div class="accordion-body text-start">
                <p class="">
                  As part of a block week on PCB design at HSLU, we were given the choice to either replicate a reference PCB provided by our professors or to create a design for a personal project. I chose to take the opportunity to work on a practical and forward-looking idea, designing a custom PCB for the next generation of my desk PC project.
                </p>
                <p class="">
                  This PCB serves as the central control unit for the desk PC, acting as its "brain." It allows the user to:
                  <ul style="margin-bottom: 0; padding-bottom: 0;">
                    <li>
                      Turn on/off the computer and also remotely start it
                    </li>
                    <li>
                      Display data such as cooling system temperatures
                    </li>
                    <li>
                      Control individual electrical consumers by toggling their power supply
                    </li>
                  </ul>
                  A project overview can be accessed at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1_94M86tpWKfXPwIlsQ-vCaz6YTmf8p0B/view?usp=sharing'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Project Overview
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingPortfolio">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsePortfolio" aria-expanded="true" aria-controls="collapsePortfolio">
                <strong>My Portfolio Website</strong>
              </button>
            </h2>
            <div id="collapsePortfolio" class="accordion-collapse collapse" aria-labelledby="headingPortfolio"
              data-bs-parent="#accordionPrivate">
              <div class="accordion-body text-start">
                <p class="">
                  During my studies at HSLU, I completed two units focused on website development. To further deepen my knowledge in this area, I decided to create my own portfolio website. While web development may not be a typical task for an electrical engineer, I saw it as a great opportunity to showcase one of my many skill sets.
                </p>
                <p class="">
                  In the future, this website may undergo a complete overhaul and could potentially evolve to serve an entirely different purpose. A project overview can be accessed at the following link:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/14rNpaCR076suzbZmpn011jCaaD4PJECZ/view?usp=sharing'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Project Overview
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingPower">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapsePower" aria-expanded="false" aria-controls="collapsePower">
                <strong>Lab Power Supply V2</strong>
              </button>
            </h2>
            <div id="collapsePower" class="accordion-collapse collapse" aria-labelledby="headingPower"
              data-bs-parent="#accordionPrivate">
              <div class="accordion-body text-start">
                <p class="">
                  In the first semester of my electrical engineering studies, I built a basic lab power supply, which was heavily used during the testing phase of my first project unit, where we developed a gravel cleaning robot. Recognizing how useful this tool was, I decided to enhance the original design by addressing some missing features.
                </p>
                <p class="">
                  The second version was designed using Fusion 360 and 3D-printed with my own 3D printer at home, allowing me to create a more compact and functional design. Key information, photos, and circuitry details can be found in the following project overview:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/1q0NkdBuuj30H5NaQPJwRcDvxzHrzZf6E/view?usp=sharing'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Project Overview
                </button>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingDesk">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseDesk" aria-expanded="false" aria-controls="collapseDesk">
                <strong>Desk PC</strong>
              </button>
            </h2>
            <div id="collapseDesk" class="accordion-collapse collapse" aria-labelledby="headingDesk"
              data-bs-parent="#accordionPrivate">
              <div class="accordion-body text-start">
                <p class="">
                  During the summer of 2020, amidst the corona pandemic, I found myself with some extra time and decided to build a desk PC. The unique aspect of this project is that all the computer hardware is completely hidden inside the desk, making it invisible at first glance.
                </p>
                <p class="">
                  To achieve this, I had to design and build the desk from scratch. One of the main challenges was the cooling system, due to the limited internal height of only 9 cm, traditional tower coolers couldn't be installed. To overcome this, I opted for a water cooling system, ensuring optimal thermal performance. Key information, photos, and other details can be found in the following project overview:
                </p>
                <button @click="
                  openFileInNewWindow(
                    'https://drive.google.com/file/d/17V8bYgCQ2ys4mMSINYPnUa6t1I5MFiZx/view?usp=sharing'
                  )
                  " type="button" class="btn btn-primary" style="
                    background-color: #eb5e28;
                    color: white;
                    border: #eb5e28;
                  ">
                  Project Overview
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeProjects",
  props: {
    msg: String,
  },
  methods: {
    openFileInNewWindow(fileName) {
      window.open(fileName, "_blank");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.projects {
  background-color: #354f52;
}

.title_projects {
  font-size: 3rem;
}

.justified-text {
  text-align: justify;
}

.p-10 {
  padding: 7rem !important;
  /* 112px */
}

.accordion-button:not(.collapsed) {
  text-emphasis-color: black;
  background-color: white;
}

.accordion-button:focus {
  box-shadow: none;
  color: white;
  background-color: #eb5e28;
}

.accordion-button:active {
  color: white;
  background-color: #eb5e28;
}

/* Media query for smartphones (up to 768px wide) */
@media (max-width: 768px) {
  .title_projects {
    padding-top: 3rem;
    padding-bottom: 0rem;
  }
}
</style>
